module.exports = __webpack_public_path__ + "static/img/filter-active.33f5124d.svg";